import styled from 'styled-components/macro';
import { colorCoreBackground1000, separatorBackGroundColor } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
export const DropdownWrapperStyled = styled.div `
  flex-basis: 100%;

  ${ADAPTIVE.minWidth.tablet} {
    flex-basis: calc(50% - 12px);
  }

  ${ADAPTIVE.minWidth.desktop} {
    flex-basis: 20%;
  }
`;
export const SeparatorStyled = styled.div `
  width: 100%;
  height: 1px;
  margin: 24px 0;
  background-color: ${separatorBackGroundColor};
`;
export const OwnerManualsItemStyled = styled.li `
  background-color: ${colorCoreBackground1000};
  border-radius: ${CORNER_RADIUS.xs};
  padding: 12px 16px;

  &:not(:last-child) {
    margin-bottom: 8px;
  }

  ${ADAPTIVE.minWidth.tablet} {
    padding: 10px 16px;
  }
`;
export const OwnerManualsListStyled = styled.ul `
  margin: 0;
  padding: 0;
  list-style: none;
`;
export const ItemFieldStyled = styled(FlexWrapper) `
  flex-basis: 25%;

  ${ADAPTIVE.maxWidth.tablet} {
    flex-grow: 0;

    &:first-child {
      ${({ isRightToLeft }) => (isRightToLeft ? 'padding-left: 20px;' : 'padding-right: 20px;')}
      flex-shrink: 0;
    }

    &:nth-child(2),
    &:nth-child(3) {
      flex-grow: 1;
      text-align: center;
    }

    &:last-child {
      flex-shrink: 0;
      ${({ isRightToLeft }) => (isRightToLeft ? 'padding-right: 20px;' : 'padding-left: 20px;')}
    }
  }
`;
export const MobileTextStyled = styled.div `
  flex-grow: 1;
  flex-basis: 75%;
`;
